import React, { useEffect, useState } from "react";
import { Navigate } from "react-router";
import YouTube from 'react-youtube';
import {
  Swiper,
  SwiperSlide
} from 'swiper/react';

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// import required modules
import {
  Pagination,
  Navigation
} from "swiper";
import CreativeNameDisplay from "../shared/CreativeNameDisplay";

function VideoGalleryPreview({ preview }) {
  let { video_urls } = preview
  let videoId = [];
  let isEmbedded = [];
  video_urls.map((item) => {
    if (item?.includes('embed')) {
      videoId.push(item?.split('/').pop());
      isEmbedded.push(true)
    }
    else {
      videoId.push(false)
      isEmbedded.push(false)
    }
  })
  return (
    <div>
      <CreativeNameDisplay preview={preview} />
      <div className="preview-inner">
        <div className="preview-gallery">
          <Swiper
            spaceBetween={50}
            pagination={true}
            navigation={true}
            modules={[Navigation, Pagination]}
            className="mySwiper h-full"
          >
            {
              video_urls
                ? video_urls.map((video_url, index) => {
                  if (isEmbedded[index] === true) {
                    return <SwiperSlide ><YouTube
                      videoId={videoId[index]}
                      opts={{
                        height: "100%",
                        width: "100%",
                      }}
                    /></SwiperSlide>
                  }
                  else {
                    return <SwiperSlide > <iframe src={video_url} style={{ width: "100%", height: "100%" }} controls referrerPolicy="no-referrer" /> </SwiperSlide>;
                  }
                })
                : null
            }
          </Swiper>
        </div>
      </div>
    </div>
  )
}

export default VideoGalleryPreview
